<template>
  <el-dialog :title="type==1?'修改线索跟进人':'批量修改跟进人'" :visible.sync="visible" width="500px">
    <span  v-for="(item,index) in rowList" :key="index">{{ item.workerName }},</span><br/><br/>
    <el-select v-if="type == 1" v-model="handler" placeholder="请选择跟进人">
      <el-option
        v-for="item in handlerList"
        :key="item.id"
        :label="item.name + (item.isChecked ? '(当前处理人)' : '')"
        :value="item.id"
        :disabled="item.isChecked"
      ></el-option>
    </el-select>
    <el-select v-else v-model="batchHandlerId" placeholder="请选择跟进人">
      <el-option
        v-for="item in allhandlerList"
        :key="item.userId"
        :label="item.userName"
        :value="item.userId"
      ></el-option>
    </el-select>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" v-if="type == 1" @click="handleConfirm"
        >确定</el-button
      >
      <el-button type="primary" v-else @click="batchHandleConfirm" >确定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import workercrmapi from "@/script/api/workercrmapi";
import taskApi from "@/script/api/taskApi";
export default {
  data() {
    return {
      visible: false,
      handler: '',
      batchHandlerId: "",
      clueId: "",
      handlerList: [],
      allhandlerList:[],
      type: "", //1单个，2批量
      rowList: []
    };
  },
  methods: {
    showModifyHandler(row, type) {
      this.type = type;
      this.visible = true;
      this.rowList=[];
      if (type == 1) {
        //单个
        this.handler = row.handler;
        this.clueId = row.id;
        this.getHandlerList();
      } else {
        // 批量
        this.rowList = row;
        this.getAllHandle();
      }
    },
    batchHandleConfirm() {
      if (this.batchHandlerId == null || this.batchHandlerId == "") {
        this.$message.error("请选择跟进人");
        return;
      }

      let that=this;
      let userName='';
      this.allhandlerList.forEach(f=>{
        if(f.userId==that.batchHandlerId){
           userName=f.userName;
        }
      })


      let req=[]
      this.rowList.forEach(f=>{
        req.push({clueId:f.id,userId:that.batchHandlerId,userName:userName})
      })

         workercrmapi.$axiosBatchSetClueFollowUser(req).then(res => {
        if (res.data.errno == 0) {
          if(res.data.data!=null&&res.data.data!=''){
              this.$message.error(res.data.data);
          }else{
            this.$message.success('修改跟进人成功');
            this.visible = false;
            this.$parent.querySearch();
          }
        } else {
          this.$message.error(res.data.errmsg);
        }
      });

    },
    handleConfirm() {
      if (this.handler == null || this.handler == '') {
        this.$message.error("请选择跟进人");
        return;
      }

      let hd={};
      let that=this;
      this.handlerList.forEach(e=>{
        if(e.id==that.handler){
          hd=e;
        }
      })

      this.$emit("confirm", {
        handler: hd,
        clueId: this.clueId
      });
      this.visible = false;
    },
    getAllHandle() {
      taskApi.$axiosGetClueHandleName().then(res => {
        this.allhandlerList = res.data.data;
      });
    },
    getHandlerList() {
      workercrmapi.$axiosGetHandlerList({ clueId: this.clueId }).then(res => {
        if (res.data.errno == 0) {
          this.handlerList = res.data.data;
        }
      });
    }
  }
};
</script>
